(() => {
  // app/scripts/components/coveo/CoveoCategoryFacet.js
  var CoveoCategoryFacet = class {
    constructor(container) {
      this.container = container;
      this.listContainer = this.container.querySelector(".js-category-links");
      this.template = this.listContainer.firstElementChild.outerHTML;
      this.callbacks = [];
    }
    update(facet) {
      if (!facet || !this.listContainer)
        return;
      this.facetId = facet.state?.facetId || "categories";
      const values = facet.state?.values || facet.values || [];
      const links = [];
      for (let index = 0; index < values.length; index++) {
        const facetItem = values[index];
        const li = this.createCategoryLink(facetItem, 1, facet);
        links.push(li);
      }
      this.listContainer.innerHTML = "";
      this.listContainer.append(...links);
    }
    createCategoryLink(facetItem, level, facet) {
      const newValue = { ...facetItem, level };
      const liHtml = ["level", "numberOfResults", "value"].reduce(
        (html, key) => html.replaceAll(`[${key}]`, newValue[key]),
        this.template
      );
      let hasActiveChild = false;
      const ul = document.createElement("ul");
      ul.innerHTML = liHtml;
      const li = ul.firstElementChild;
      li.addEventListener("click", (event) => {
        event.stopPropagation();
        this.callbacks.forEach((callback) => callback(this.facetId, facetItem));
      });
      if (facetItem.children.length > 0) {
        const ul2 = li.querySelector("ul");
        for (let index = 0; index < facetItem.children.length; index++) {
          const item = facetItem.children[index];
          const li2 = this.createCategoryLink(item, level + 1, facet);
          ul2.append(li2);
        }
        hasActiveChild = [...ul2.children].some((child) => child.classList.contains("is-active"));
      }
      const isActive = facetItem.state === "selected" || hasActiveChild;
      li.classList.remove("js-template", "hidden");
      li.classList.toggle("is-active", isActive);
      return li;
    }
    onClick(callback) {
      this.callbacks.push(callback);
    }
  };

  // app/scripts/coveo-search-analytics.js
  var ANALYTICS_EVENT_TYPE = "search";
  var CoveoSearchAnalytics = class {
    constructor(engine) {
      this.engine = engine;
    }
    get _config() {
      const { organizationId, accessToken, analytics } = this.engine.configuration;
      return {
        organizationId,
        accessToken,
        trackingId: analytics.trackingId
      };
    }
    get _endpoint() {
      const { organizationId } = this._config;
      return `https://${organizationId}.analytics.org.coveo.com/rest/ua/v15/analytics/${ANALYTICS_EVENT_TYPE}`;
    }
    get _searchState() {
      return this.engine.store.getState().commerceSearch || {};
    }
    _getClientId() {
      try {
        return this.engine.relay.getMeta("").clientId;
      } catch (error) {
        console.warn(`[CoveoSearchAnalytics] Failed to get clientId:`, error);
        return void 0;
      }
    }
    _getFacetState(pendingChange = null) {
      const { facets } = this._searchState;
      if (!Array.isArray(facets))
        return [];
      return facets.flatMap(
        (facet) => facet.values.reduce((acc, v, index) => {
          let isSelected = v.state === "selected";
          if (pendingChange && pendingChange.facetId === facet.facetId && pendingChange.value === v.value) {
            isSelected = pendingChange.action === "select";
          }
          if (isSelected) {
            acc.push({
              field: facet.facetId,
              id: facet.facetId,
              title: facet.displayName || facet.facetId,
              facetType: "specific",
              value: v.value,
              valuePosition: index + 1,
              displayValue: v.value,
              state: "selected"
            });
          }
          return acc;
        }, [])
      );
    }
    _buildPayload(actionCause, customData = {}, { pendingChange = null, responseId: responseIdOverride } = {}) {
      const { trackingId } = this._config;
      const state = this.engine.store.getState();
      const { responseId, queryExecuted } = state.commerceSearch || {};
      const language = state.commerceContext?.language || document.documentElement.lang || "en";
      return {
        actionCause,
        searchQueryUid: responseIdOverride || responseId,
        queryText: queryExecuted || "",
        language,
        originLevel1: trackingId,
        originLevel2: "default",
        originLevel3: window.location.href,
        clientId: this._getClientId(),
        anonymous: false,
        responseTime: 0,
        customData,
        facetState: this._getFacetState(pendingChange ?? null)
      };
    }
    async logSearchEvent(actionCause, customData = {}, options = {}) {
      const { accessToken } = this._config;
      if (!accessToken || !this.engine.configuration.analytics.enabled)
        return;
      const payload = this._buildPayload(actionCause, customData, options);
      try {
        const response = await fetch(this._endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          console.warn(`[CoveoSearchAnalytics] ${actionCause} failed:`, response.status);
        }
      } catch (error) {
        console.warn(`[CoveoSearchAnalytics] ${actionCause} error:`, error);
      }
    }
    logInterfaceLoad() {
      return this.logSearchEvent("interfaceLoad");
    }
    logSearchboxSubmit() {
      return this.logSearchEvent("searchboxSubmit");
    }
    logSearchFromLink() {
      return this.logSearchEvent("searchFromLink");
    }
    logOmniboxAnalytics(metadata = {}) {
      return this.logSearchEvent("omniboxAnalytics", metadata);
    }
    logRecommendationInterfaceLoad(responseId) {
      return this.logSearchEvent("recommendationInterfaceLoad", {}, { responseId });
    }
    logFacetSelect(facetId, facetValue) {
      return this.logSearchEvent("facetSelect", {
        facetId,
        facetValue,
        facetField: facetId
      }, { pendingChange: { facetId, value: facetValue, action: "select" } });
    }
    logFacetDeselect(facetId, facetValue) {
      return this.logSearchEvent("facetDeselect", {
        facetId,
        facetValue,
        facetField: facetId
      }, { pendingChange: { facetId, value: facetValue, action: "deselect" } });
    }
    logFacetClearAll() {
      return this.logSearchEvent("facetClearAll");
    }
  };
  var coveo_search_analytics_default = CoveoSearchAnalytics;

  // app/scripts/coveo-facet.js
  var MAX_FACET_VALUES = 1e4;
  var CoveoFacet = class extends HTMLElement {
    constructor() {
      super();
      this.callbacks = [];
      this.pendingFacetChanges = /* @__PURE__ */ new Map();
      this.selectedFacets = /* @__PURE__ */ new Set();
      this.isInitialized = false;
      this.isShowingMoreValues = false;
      this.expandedFacets = /* @__PURE__ */ new Set();
      this.handleFacetClick = this.handleFacetClick.bind(this);
    }
    /**
     * When component is connected to DOM
     */
    connectedCallback() {
      this.container = this.querySelector(".js-facets-container");
      const temp = this.querySelector(".js-facet-template");
      this.facetTemplate = temp.outerHTML;
      this.selectedFacetsContainer = this.querySelector(".js-selected-filters");
      this.selectedFacetTemplate = this.selectedFacetsContainer.innerHTML;
      this.selectedFacetsContainer.innerHTML = "";
      this.categoryFacetContainer = this.querySelector("#facet-categories-links");
      this.categoryFacet = new CoveoCategoryFacet(this.categoryFacetContainer);
      this.initSearch();
      this.listenToResize();
      this.initApplyFiltersButton();
      this.initClearAllFacetsButton();
    }
    init(facetGenerator, engine) {
      const { loadCoreFacetActions, loadCategoryFacetSetActions, loadRegularFacetActions } = coveoheadless;
      const { selectedFacets } = this;
      this.engine = engine;
      this.analytics = new coveo_search_analytics_default(engine);
      this.facetGenerator = facetGenerator;
      this.coreFacetActions = loadCoreFacetActions(this.engine);
      this.categoryFacetActions = loadCategoryFacetSetActions(this.engine);
      this.regularFacetActions = loadRegularFacetActions(this.engine);
      this.facetGenerator.facets.forEach((facet) => {
        facet.state.values.forEach((value) => {
          if (value.state === "selected") {
            selectedFacets.add(this.createFacetKey(facet.state.facetId, value.value));
          }
        });
      });
      this.isInitialized = true;
      this.categoryFacet.onClick(this.handleCategoryFacetValueChange.bind(this));
    }
    /**
     * Render the facets
     */
    render() {
      const facetScrollPositions = /* @__PURE__ */ new Map();
      this.container.querySelectorAll("details[data-facet-id]").forEach((details) => {
        const list = details.querySelector("[data-facet-list]");
        if (list && list.scrollTop > 0) {
          facetScrollPositions.set(details.dataset.facetId, list.scrollTop);
        }
      });
      const openFacetIds = new Set(
        [...this.container.querySelectorAll("details[open]")].map((d) => d.dataset.facetId).filter(Boolean)
      );
      this.container.innerHTML = "";
      this.renderSelectedFacets();
      let isCategoryFacetRendered = false;
      this.facetGenerator.facets.forEach((facet) => {
        const div = document.createElement("div");
        div.innerHTML = this.facetTemplate;
        const facetGroup = div.firstElementChild;
        facetGroup.dataset.facetId = facet.state.facetId;
        const summary = facetGroup.querySelector("summary");
        if (summary)
          summary.setAttribute("aria-label", facet.state.displayName);
        const titleEl = facetGroup.querySelector(".js-filter-title");
        if (titleEl)
          titleEl.textContent = facet.state.displayName;
        const legend = facetGroup.querySelector("legend");
        if (legend)
          legend.textContent = facet.state.displayName;
        facetGroup.classList.remove("hidden");
        const facetBody = facetGroup.querySelector("[data-facet-list]");
        if (facet.state.facetId === "availability" || facet.state.hasActiveValues || openFacetIds.has(facet.state.facetId)) {
          facetGroup.open = true;
        }
        switch (facet.type) {
          case "regular":
            this.renderRegularFacet(facet, facetBody);
            break;
          case "hierarchical":
            const { updateCategoryFacetNumberOfValues } = this.categoryFacetActions;
            isCategoryFacetRendered = true;
            this.engine.dispatch(updateCategoryFacetNumberOfValues({ facetId: "categories", numberOfValues: 100 }));
            return this.categoryFacet.update(facet);
        }
        this.container.appendChild(facetGroup);
      });
      this.categoryFacet.container.classList.toggle("hidden", !isCategoryFacetRendered);
      if (facetScrollPositions.size) {
        requestAnimationFrame(() => {
          facetScrollPositions.forEach((scrollTop, facetId) => {
            const list = this.container.querySelector(`details[data-facet-id="${facetId}"] [data-facet-list]`);
            if (list)
              list.scrollTop = scrollTop;
          });
        });
      }
    }
    renderSelectedFacets() {
      const { selectedFacetsContainer, selectedFacets, selectedFacetTemplate } = this;
      selectedFacetsContainer.innerHTML = "";
      let itemsCount = 0;
      for (const facetKey of selectedFacets) {
        const [facetId, value] = facetKey.split("::");
        const foundFacet = this.findFacet(facetId);
        const facetType = foundFacet.type;
        const newValue = this.parseValue(value);
        itemsCount++;
        const div = document.createElement("div");
        div.innerHTML = selectedFacetTemplate;
        const button = div.firstElementChild;
        const labelSpan = button.querySelector("span");
        if (labelSpan) {
          labelSpan.textContent = facetId === "availability" ? theme.string.inStock : newValue;
        }
        button.addEventListener("click", () => {
          if (button.disabled)
            return;
          button.disabled = true;
          this.removeSelectedFacet(facetId, facetType, value);
        });
        selectedFacetsContainer.appendChild(button);
      }
      selectedFacetsContainer.dataset.selectedFacets = itemsCount;
    }
    /**
     * Render a regular facet with checkboxes
     */
    renderRegularFacet(facet, container) {
      let {
        state: { facetId, values: facetOptions },
        type
      } = facet;
      const liTemplate = container.innerHTML;
      container.innerHTML = "";
      if (facetId === "availability") {
        const option = facetOptions.find((option2) => option2.value === "True") || { state: "idle", value: "True" };
        facetOptions = [option];
      }
      facetOptions.forEach((option) => this.renderCheckboxFacet(facetId, type, option, container, liTemplate));
      const showMoreBtn = container.parentElement.querySelector(".js-show-more-btn");
      if (showMoreBtn) {
        showMoreBtn.classList.toggle("hidden", !facet.state.canShowMoreValues || this.expandedFacets.has(facetId));
        showMoreBtn.addEventListener("click", () => {
          showMoreBtn.closest("details")?.classList.add("is-loading-more");
          this.isShowingMoreValues = true;
          this.expandedFacets.add(facetId);
          const { updateCoreFacetNumberOfValues } = this.coreFacetActions;
          this.engine.dispatch(updateCoreFacetNumberOfValues({ facetId: facet.state.facetId, numberOfValues: MAX_FACET_VALUES }));
          facet.showMoreValues();
        });
      }
    }
    renderCheckboxFacet(facetId, facetType, { value, state }, container, template) {
      const newValue = this.parseValue(value);
      const div = document.createElement("div");
      div.innerHTML = template;
      const item = div.firstElementChild;
      const checkbox = item.querySelector("input");
      const inputId = `${facetId}-${newValue}`;
      checkbox.id = inputId;
      checkbox.checked = this.selectedFacets.has(this.createFacetKey(facetId, value));
      const label = item.querySelector("label");
      if (label)
        label.setAttribute("for", inputId);
      const labelSpan = item.querySelector("label span.flex-1");
      if (labelSpan) {
        labelSpan.textContent = facetId === "availability" ? theme.string.inStock : `${newValue}`;
      }
      checkbox.addEventListener("change", (event) => {
        this.handleFacetClick(facetId, facetType, value, event.target.checked);
      });
      checkbox.setAttribute("data-facet-id", facetId);
      container.appendChild(item);
    }
    parseValue(value) {
      try {
        const parsedValue = JSON.parse(value);
        if (Array.isArray(parsedValue)) {
          const value2 = parsedValue[0];
          if (!(typeof value2 === "object")) {
            return value2;
          }
          if (typeof value2 === "object") {
            return value2[Shopify.locale] || value2[Object.keys(value2)[0]];
          }
          return value2;
        }
        return parsedValue;
      } catch (error) {
        return value;
      }
    }
    /**
     * Handle facet checkbox click
     */
    handleFacetClick(facetId, facetType, value, checked) {
      if (checked) {
        this.addSelectedFacet(facetId, facetType, value);
      } else {
        this.removeSelectedFacet(facetId, facetType, value);
      }
    }
    /**
     * Add a selected facet value
     */
    addSelectedFacet(facetId, facetType, value) {
      const facetKey = this.createFacetKey(facetId, value);
      if (this.selectedFacets.has(facetKey))
        return;
      this.selectedFacets.add(facetKey);
      const facet = this.findFacet(facetId);
      const facetValue = facet.state.values.find((v) => v.value === value) || { value };
      this.handleFacetValueChange(facetType, facetId, facetValue, "add");
      this.analytics?.logFacetSelect(facetId, value);
    }
    /**
     * Remove a selected facet value
     */
    removeSelectedFacet(facetId, facetType, value) {
      const facetKey = this.createFacetKey(facetId, value);
      if (!this.selectedFacets.has(facetKey))
        return;
      this.selectedFacets.delete(facetKey);
      const facet = this.findFacet(facetId);
      const facetValue = facet.state.values.find((v) => v.value === value) || { value };
      this.handleFacetValueChange(facetType, facetId, facetValue, "remove");
      this.analytics?.logFacetDeselect(facetId, value);
    }
    /**
     * Clear all selected facets
     */
    clearAllFacets() {
      this.analytics?.logFacetClearAll();
      this.selectedFacets.clear();
      this.facetGenerator.deselectAll();
      this.render();
    }
    initSearch() {
      const searchContainer = this.querySelector(".js-search-container");
      const input = searchContainer.querySelector("input");
      const clearButton = searchContainer.querySelector("button");
      input.addEventListener("input", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const { value } = event.target;
        const filterTitleElms = this.querySelectorAll(".js-filter-title");
        !!value ? input.classList.add("is-typing") : input.classList.remove("is-typing");
        filterTitleElms.forEach((element) => {
          const title = element.innerHTML.toLowerCase();
          const details = element.closest("details");
          if (title.includes(value.trim().toLowerCase())) {
            details.open = true;
            details.classList.remove("hidden");
          } else {
            details.classList.add("hidden");
          }
        });
      });
      clearButton.addEventListener("click", (event) => {
        input.value = "";
        input.classList.remove("is-typing");
        input.dispatchEvent(new Event("input"));
      });
    }
    handleFacetValueChange(facetType, facetId, facetValue, action) {
      switch (facetType) {
        case "regular":
          this.handleRegularFacetValueChange(facetId, facetValue, action);
          break;
      }
      this.handleUnappliedSelectedFacets(facetId, facetValue, action);
    }
    async handleCategoryFacetValueChange(facetId, facetValue) {
      const foundFacet = this.findFacet(facetId);
      foundFacet.toggleSelect(facetValue);
    }
    handleRegularFacetValueChange(facetId, facetValue, action) {
      if (this.isSmallScreen()) {
        return;
      }
      const selection = { ...facetValue, state: action === "add" ? "selected" : "idle" };
      const foundFacet = this.findFacet(facetId);
      foundFacet.toggleSelect(selection);
    }
    handleUnappliedSelectedFacets(facetId, facetValue, action) {
      if (!this.isSmallScreen()) {
        return;
      }
      const facetKey = this.createFacetKey(facetId, facetValue.value);
      if (this.pendingFacetChanges.has(facetKey)) {
        this.pendingFacetChanges.delete(facetKey);
      } else {
        this.pendingFacetChanges.set(facetKey, { facetId, facetValue, action });
      }
      this.setState(this.pendingFacetChanges.size ? "show-apply-button" : "hide-apply-button");
    }
    onApplyFilters(callback) {
      this.callbacks.push(callback);
    }
    dispatchApplyFilters() {
      for (const { facetId, facetValue, action } of this.pendingFacetChanges.values()) {
        const selection = { ...facetValue, state: action === "add" ? "selected" : "idle" };
        this.engine.dispatch(
          this.regularFacetActions.toggleSelectFacetValue({ facetId, selection })
        );
      }
      this.callbacks.forEach((callback) => callback());
      this.pendingFacetChanges.clear();
      this.setState("hide-apply-button");
    }
    isSmallScreen() {
      return window.matchMedia("(max-width: 989.9px)").matches;
    }
    setState(state) {
      switch (state) {
        case "loading":
          this.classList.add("is-loading");
          break;
        case "show-apply-button":
          this.classList.add("is-show-apply");
          break;
        case "hide-apply-button":
          this.classList.remove("is-show-apply");
          break;
        case "reset":
          this.classList.remove("is-loading");
          break;
      }
    }
    listenToResize() {
      window.addEventListener("resize", () => {
        if (!this.isSmallScreen() && this.pendingFacetChanges.size) {
          this.dispatchApplyFilters();
        }
      });
    }
    initApplyFiltersButton() {
      const button = this.querySelector(".js-apply-filters");
      button?.addEventListener("click", this.dispatchApplyFilters.bind(this));
    }
    initClearAllFacetsButton() {
      const button = this.querySelector(".js-clear-button");
      button?.addEventListener("click", this.clearAllFacets.bind(this));
    }
    findFacet(facetId) {
      return this.facetGenerator.facets.find((facet) => facet.state.facetId === facetId);
    }
    createFacetKey(facetId, value) {
      return `${facetId}::${value}`;
    }
    selectedFacetsCount() {
      return this.selectedFacets.size;
    }
  };
  customElements.define("coveo-facet", CoveoFacet);
  var coveo_facet_default = CoveoFacet;
})();
